import { configureStore } from "@reduxjs/toolkit";
import agentsSlice from "./reducers/appReducer";

export default configureStore({
  reducer: {
    agents: agentsSlice
  },
})